import angular from 'angular';
import { capitalizeLicense } from './capitalize-license.filter/capitalize-license';
import { daysBetweenFilter } from './days-between.filter/days-between';
import { hasAnyLicenseOfTypeActiveFilter } from './has-license-type.filter/has-any-license-of-type-active';
import { hasLicenseTypeFilter } from './has-license-type.filter/has-license-type';
import { hasSelfHostedLicense } from './has-license-type.filter/has-self-hosted-license';
import { hasWebHostedLicenseFilter } from './has-license-type.filter/has-web-hosted-license';
import { licenseIsExpiring } from './has-license-type.filter/license-is-expiring';
import { LicenseListService } from './license-list.service/licenseList';
import { LicenseTableRowsComponent } from './license-table.directive/license-table-rows';
import { LicenseService } from './license.service/license-service';
import {
    UpgradeRenewLicensesController,
    populateUpgradeRenewLicenseTemplateCache,
} from './upgrade-renew-licenses.view/upgrade-renew-licenses';
import { YourFonts } from './your-fonts-listing.directive/your-fonts';



export default angular
    .module('tn.licenses', [])
    // components
    .controller('tnUpgradeRenewLicenses', UpgradeRenewLicensesController)
    .component('licenseTableRows', LicenseTableRowsComponent)
    .directive('yourFontsList', YourFonts)

    // providers
    .filter('capitalizeLicense', capitalizeLicense)
    .filter('daysBetween', daysBetweenFilter)
    .filter('hasAnyLicenseOfTypeActive', hasAnyLicenseOfTypeActiveFilter)
    .filter('hasLicenseType', hasLicenseTypeFilter)
    .filter('hasSelfHostedLicense', hasSelfHostedLicense)
    .filter('hasWebHostedLicense', hasWebHostedLicenseFilter)
    .filter('licenseIsExpiring', licenseIsExpiring)
    .service('tnLicenseListService', LicenseListService)
    .service('tnLicenseService', LicenseService)
    // bootstrap
    .run(populateUpgradeRenewLicenseTemplateCache).name;
